import { render } from "./DashboardSearchAndListView.vue?vue&type=template&id=ff45c686&ts=true"
import script from "./DashboardSearchAndListView.vue?vue&type=script&lang=ts"
export * from "./DashboardSearchAndListView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__